<template>
  <div>
    <v-alert
      v-model="alertState"
      :color="isError ? 'red' : 'green'"
      class="mt-3"
      dark
      dismissible>
      <span v-if="Array.isArray(alertMessage)">
        <span v-for="(message, idx) in alertMessage" :key="idx"> {{ message }} <br v-if="idx!==alertMessage.length"></span>
      </span>
      <span v-else>
        {{ alertMessage }}
      </span>
    </v-alert>
    <iframe
      id="nettexFrame"
      name="nettexFrame"
      :src="getNettexSrc"
      style="width: 0; height: 0; position: absolute; left: -10px; top: -10px;"
    />

    <iframe
      id="orderingFrame"
      name="orderingFrame"
      :src="getOrderingSrc"
      style="width: 0; height: 0; position: absolute; left: -10px; top: -10px;"
    />
  </div>
</template>

<script>
export default {
  name: 'CookieHelper',
  props: {
    cookieName: String
  },
  data: () => ({
    // nettexSrc: 'http://localhost:3000/cookieHelper',
    // orderingSrc: 'http://localhost:8000/cookieHelper',
    nettexSrc: 'https://nettex.web.app/cookieHelper',
    orderingSrc: 'https://ordering-nettex.web.app/cookieHelper',
    nettexDone: false,
    orderingDone: false,
    alertState: false,
    isError: false,
    alertMessage: '',
  }),
  computed: {
    getNettexSrc() {
      return this.nettexSrc
    },
    getOrderingSrc() {
      return this.orderingSrc
    },
  },
  mounted() {
    window.addEventListener('message', this.iFrameMessageHandler)
    setInterval(this.messageJumper, 1000)
  },
  methods: {
    messageJumper() {
      if (!this.nettexDone || !this.orderingDone) return
      this.$emit('cookiesDone')
    },
    iFrameMessageHandler(event) {
      console.log('auth-received-event', event)
      if (event.data && typeof event.data === 'object') {
        //? Implicitly handling undefined
        if (event.data.type === 'request') this.handleRequest(event)
        else if (event.data.type === 'response') this.handleResponse(event)
      }
      //? Other messages will pass through this handler too
    },
    handleRequest(event) {
      const cName = this.cookieName
      const cValue = this.$cookies.get(cName)
      const message = { from: 'nettex-auth', type: 'response', cName, cValue }
      if (event.data.from === 'nettex') {
        event.source.postMessage(message, this.nettexSrc.split('/').slice(0, -1).join('/')) // Remove path from origin
      } else if (event.data.from === 'ordering') {
        event.source.postMessage(message, this.orderingSrc.split('/').slice(0, -1).join('/')) // Remove path from origin
      }
    },
    handleResponse(event) {
      if (event.data.success === true) {
        if (event.data.from === 'nettex') {
          this.nettexDone = true
          console.log('parent: success from [nettex]')
        } else if (event.data.from === 'ordering') {
          this.orderingDone = true
          console.log('parent: success from [ordering]')
        } else {
          console.log(`Response from unknown service [${event.data.from}]`)
        }
      } else if (event.data.success === false) {
        console.log(`Parent: Operation failure reported by [${event.data.from}]`)
      }
    },
  }
}
</script>
